import { Suspense, lazy } from 'react';

import { KDErrorBoundary } from '@/components';
import { KDLayoutDashboardLoader } from '@/layouts';

const UsersFormPage = lazy(() => import('./UsersForm.page'));

export const UsersForm = () => {
  return (
    <KDErrorBoundary>
      <Suspense fallback={<KDLayoutDashboardLoader />}>
        <UsersFormPage />
      </Suspense>
    </KDErrorBoundary>
  );
};
